// Autogenerated locales - do not modify
/* tslint:disable quotemark variable-name */
export const CONTEST_POSTS_OLD_CONTESTS = "Star\u0161ie s\u00fa\u0165a\u017ee...";
export const CONTEST_POSTS_TITLE = "Prebiehaj\u00face s\u00fa\u0165a\u017ee";
